// Pure password policy used by both backend (DomainError) and frontend
// (live feedback in the activate / reset forms). Keeping the rules here
// guarantees the two sides cannot drift.
export const PASSWORD_MIN_LENGTH = 10;
const HAS_UPPERCASE = /[A-Z]/;
const HAS_NUMBER = /\d/;
const HAS_SPECIAL = /[^A-Za-z0-9]/;
export function validatePassword(plain) {
    const out = [];
    if (plain.length < PASSWORD_MIN_LENGTH)
        out.push({ rule: 'min_length' });
    if (!HAS_UPPERCASE.test(plain))
        out.push({ rule: 'uppercase' });
    if (!HAS_NUMBER.test(plain))
        out.push({ rule: 'number' });
    if (!HAS_SPECIAL.test(plain))
        out.push({ rule: 'special' });
    return out;
}
export function isPasswordStrong(plain) {
    return validatePassword(plain).length === 0;
}
//# sourceMappingURL=password-policy.js.map